import { ErrorHandler } from '@angular/core';

/**
 * ErrorHandler peso-pluma que delega para o Sentry quando disponível.
 * Evita o import estático de @sentry/angular no app.config.ts,
 * removendo ~393KB do bundle inicial.
 *
 * NÃO faz import do Sentry no constructor — isso dispararia o download
 * durante o bootstrap. Em vez disso, carrega o handler real sob demanda
 * (no primeiro erro) ou após 5s via setTimeout em main.ts.
 */
export class DeferredSentryErrorHandler implements ErrorHandler {
  private sentryHandler: ErrorHandler | null = null;
  private loadingPromise: Promise<void> | null = null;

  handleError(error: any): void {
    if (this.sentryHandler) {
      this.sentryHandler.handleError(error);
    } else {
      // Fallback: log no console + tenta carregar Sentry para próximos erros
      console.error('[DeferredSentry]', error);
      this.ensureLoaded();
    }
  }

  /** Carrega o handler real sob demanda (lazy). Chamado no primeiro erro. */
  private ensureLoaded(): void {
    if (this.loadingPromise) return;
    this.loadingPromise = import('@sentry/angular')
      .then((m) => {
        this.sentryHandler = m.createErrorHandler();
      })
      .catch(() => {
        // Se falhar, continua usando console.error
      });
  }
}
